import { Injectable } from "@angular/core";
import { Observable, Subscriber } from "rxjs";
import { ReduxAction } from "../../model/redux.action.model";
import {
  ACTIVATE_RECEIVE,
  ACTIVATE_REQUEST,
  CHANGE_STATE,
  CONFIRM_LOGIN_RECEIVE,
  CONFIRM_LOGIN_REQUEST,
  DefaultActionFactory,
  GET_RESOURCES_RECEIVE,
  GET_RESOURCES_REQUEST,
  GET_STATUS_RECEIVE,
  GET_STATUS_REQUEST,
  GET_SUPPORTLINKS_RECEIVE,
  GET_SUPPORTLINKS_REQUEST,
  LOGIN_RECEIVE,
  LOGIN_REQUEST, LOGOUT_RECEIVE, LOGOUT_REQUEST,
  MODIFY_STATIC_PASSWORD_RECEIVE,
  MODIFY_STATIC_PASSWORD_REQUEST,
  RESEND_CONFIRMIATION_CODE_RECEIVE, RESEND_CONFIRMIATION_CODE_REQUEST,
  RESET_DEFAULT_STATE
} from "./default.action.factory";
import {
  DefaultService,
  LoginConfirmRequest,
  LoginRequest, LoginResponse,
  ResendConfirmationCodeRequest,
  SupportLinksResponse,
  ActivateStaticPasswordRequest
} from "../../../../../api/index";
import { Store } from "@ngrx/store";

@Injectable()
export class DefaultActionFactoryImpl implements DefaultActionFactory {

  protected _ngrxStore: Store<any>;
  protected _defaultService: DefaultService;

  constructor(ngrxStore: Store<any>,
              defaultService: DefaultService) {
    this._ngrxStore = ngrxStore;
    this._defaultService = defaultService;
  }

  // LOGIN
  public login(req: LoginRequest): Observable<LoginResponse> {
    return new Observable<LoginResponse>((
      subscriber: Subscriber<any>
    ) => {
      this.requestLogin(req);
      this._defaultService.login(req)
        .subscribe(
          (resp: any) => {
            this.receiveLogin(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

      return function unsubscribe() {

      };
    });
  }

  protected requestLogin(req: LoginRequest): void {
    this._ngrxStore.dispatch(this.getRequestLoginAction(req));
  }

  protected receiveLogin(resp: any): void {
    this._ngrxStore.dispatch(this.getReceiveLoginAction(resp));
  }

  protected getRequestLoginAction(req: LoginRequest): ReduxAction<any> {
    return {
      type: LOGIN_REQUEST,
      payload: req
    };
  }

  protected getReceiveLoginAction(resp: any): ReduxAction<any> {
    return {
      type: LOGIN_RECEIVE,
      payload: resp
    };
  }

  // LOGIN CONFIRM
  public confirmLogin(req: LoginConfirmRequest): Observable<Object> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestLoginConfirm(req);

      this._defaultService.loginconfirm(req)
        .subscribe(
          (resp: any) => {
            this.receiveLoginConfirm(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

      return function unsubscribe() {

      };
    });
  }

  protected requestLoginConfirm(req: LoginConfirmRequest): void {
    this._ngrxStore.dispatch(this.getRequestLoginConfirmAction(req));
  }

  protected receiveLoginConfirm(resp: any): void {
    this._ngrxStore.dispatch(this.getReceiveLoginConfirmAction(resp));
  }

  protected getRequestLoginConfirmAction(req: LoginConfirmRequest): ReduxAction<any> {
    return {
      type: CONFIRM_LOGIN_REQUEST,
      payload: req
    };
  }

  protected getReceiveLoginConfirmAction(resp: any): ReduxAction<any> {
    return {
      type: CONFIRM_LOGIN_RECEIVE,
      payload: resp
    };
  }

  // RESEND CONFIRMATION CODE
  public resendConfirmationCode( req: ResendConfirmationCodeRequest ): Observable<Object> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestResendConfirmationCode(req);

      this._defaultService.resendconfirmationcode(req)
        .subscribe(
          (resp: any) => {
            this.receiveResendConfirmationCode(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

      return function unsubscribe() {

      };
    });
  }

  protected requestResendConfirmationCode(req: ResendConfirmationCodeRequest): void {
    this._ngrxStore.dispatch(this.getRequestResendConfirmationCodeAction(req));
  }

  protected receiveResendConfirmationCode(resp: any): void {
    this._ngrxStore.dispatch(this.getRceiveResendConfirmationCodeAction(resp));
  }

  protected getRequestResendConfirmationCodeAction(req: ResendConfirmationCodeRequest): ReduxAction<Object> {
    return {
      type: RESEND_CONFIRMIATION_CODE_REQUEST,
      payload: req
    };
  }

  protected getRceiveResendConfirmationCodeAction(resp: any): ReduxAction<Object> {
    return {
      type: RESEND_CONFIRMIATION_CODE_RECEIVE,
      payload: resp
    };
  }

  // MODIFY PASSWORD
  public modifyStaticPassword(req: any): Observable<Object> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestModifyStaticPassword(req);

      this._defaultService.modify(req)
        .subscribe(
          (resp: any) => {
            this.receiveModifyStaticPassword(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

        return function unsubscribe() {

      };
    });
  }

  protected requestModifyStaticPassword(req: any): void {
    this._ngrxStore.dispatch(this.getRequestModifyStaticPasswordAction(req));
  }

  protected receiveModifyStaticPassword(resp: any): void {
    this._ngrxStore.dispatch(this.getReceiveModifyStaticPasswordAction(resp));
  }

  protected getRequestModifyStaticPasswordAction(req: any): ReduxAction<any> {
    return {
      type: MODIFY_STATIC_PASSWORD_REQUEST,
      payload: req
    };
  }

  protected getReceiveModifyStaticPasswordAction(resp: any): ReduxAction<any> {
    return {
      type: MODIFY_STATIC_PASSWORD_RECEIVE,
      payload: resp
    };
  }

  // ACTIVATE CARD
  public activateCard(req: ActivateStaticPasswordRequest): Observable<Object> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestActivateCard(req);

      this._defaultService.activate(req)
        .subscribe(
          (resp: any) => {
            this.receiveActivateCard(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

      return function unsubscribe() {

      };
    });
  }

  protected requestActivateCard(req: any): void {
    this._ngrxStore.dispatch(this.getRequestActivateCardAction(req));
  }

  protected receiveActivateCard(resp: any): void {
    this._ngrxStore.dispatch(this.getReceiveActivateCardAction(resp));
  }

  protected getRequestActivateCardAction(req: any): ReduxAction<any> {
    return {
      type: ACTIVATE_REQUEST,
      payload: req
    };
  }

  protected getReceiveActivateCardAction(resp: any): ReduxAction<any> {
    return {
      type: ACTIVATE_RECEIVE,
      payload: resp
    };
  }

  // GET STATUS
  public getStatus(): Observable<any> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestGetStatus();

      this._defaultService.status()
        .subscribe(
          (resp: any) => {
            this.receiveGetStatus(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

      return function unsubscribe() {

      };
    });
  }

  protected requestGetStatus(): void {
    this._ngrxStore.dispatch(this.getRequestGetStatusAction());
  }

  protected receiveGetStatus(resp: any): void {
    this._ngrxStore.dispatch(this.getReceiveGetStatusAction(resp));
  }

  protected getRequestGetStatusAction(): ReduxAction<any> {
    return {
      type: GET_STATUS_REQUEST
    };
  }

  protected getReceiveGetStatusAction(resp: any): ReduxAction<any> {
    return {
      type: GET_STATUS_RECEIVE,
      payload: resp
    };
  }

  // GET RESOURCES
  public getResources(): Observable<any> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestGetResources();

      this._defaultService.resource()
        .subscribe(
          (resp: any) => {
            this.receiveGetResources(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

      return function unsubscribe() {

      };
    });
  }

  protected requestGetResources(): void {
    this._ngrxStore.dispatch(this.getRequestGetResourcesAction());
  }

  protected receiveGetResources(resp: any): void {
    this._ngrxStore.dispatch(this.getReceiveGetResourcesAction(resp));
  }

  protected getRequestGetResourcesAction(): ReduxAction<any> {
    return {
      type: GET_RESOURCES_REQUEST
    };
  }

  protected getReceiveGetResourcesAction(resp: any): ReduxAction<any> {
    return {
      type: GET_RESOURCES_RECEIVE,
      payload: resp
    };
  }

  // GET SUPPORTLINKS
  public getSupportLinks(): Observable<SupportLinksResponse> {
    return new Observable<SupportLinksResponse>((
      subscriber: Subscriber<any>
    ) => {
      this.requestGetSupportLinks();

      this._defaultService.supportLinks()
        .subscribe(
          (resp: any) => {
            this.receiveGetSupportLinks(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

      return function unsubscribe() {

      };
    });
  }

  protected requestGetSupportLinks(): void {
    this._ngrxStore.dispatch(this.getRequestGetSupportLinksAction());
  }

  protected receiveGetSupportLinks(resp: any): void {
    this._ngrxStore.dispatch(this.getReceiveGetSupportLinksAction(resp));
  }

  protected getRequestGetSupportLinksAction(): ReduxAction<SupportLinksResponse> {
    return {
      type: GET_SUPPORTLINKS_REQUEST
    };
  }

  protected getReceiveGetSupportLinksAction(resp: SupportLinksResponse): ReduxAction<SupportLinksResponse> {
    return {
      type: GET_SUPPORTLINKS_RECEIVE,
      payload: resp
    };
  }

  // LOGOUT
  public logout(): Observable<any> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestLogout();

      this._defaultService.logout()
        .subscribe(
          (resp: any) => {
            this.receiveLogout(resp);
            subscriber.next(resp);
            subscriber.complete();
          },
          error => {
            subscriber.error(error);
          });

      return function unsubscribe() {

      };
    });
  }

  protected requestLogout(): void {
    this._ngrxStore.dispatch(this.getRequestLogoutAction());
  }

  protected receiveLogout(resp: any): void {
    this._ngrxStore.dispatch(this.getReceiveLogoutAction(resp));
  }

  protected getRequestLogoutAction(): ReduxAction<any> {
    return {
      type: LOGOUT_REQUEST
    };
  }

  protected getReceiveLogoutAction(resp: any): ReduxAction<any> {
    return {
      type: LOGOUT_RECEIVE,
      payload: resp
    };
  }

  // CHANGE STATE DATA for store or modyfy state data
  public changeState(req: any): Observable<any> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestChangeState(req);
      subscriber.next(req);
      subscriber.complete();
      return function unsubscribe() {
      };
    });
  }

  protected requestChangeState(req: any): void {
    this._ngrxStore.dispatch(this.getRequestChangeStateAction(req));
  }

  protected getRequestChangeStateAction(req: any): ReduxAction<any> {
    return {
      type: CHANGE_STATE,
      payload: req
    };
  }

  // RESET STATE DATA on logout
  public resetState(): Observable<any> {
    return new Observable<Object>((
      subscriber: Subscriber<any>
    ) => {
      this.requestResetState();
      subscriber.next();
      subscriber.complete();
      return function unsubscribe() {
      };
    });
  }

  protected requestResetState(): void {
    this._ngrxStore.dispatch(this.getRequestResetStateAction());
  }

  protected getRequestResetStateAction(): ReduxAction<any> {
    return {
      type: RESET_DEFAULT_STATE
    };
  }
}
